import { Dictionary } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { EduContentBookInterface, MethodInterface } from '../../+models';
import { EduContentBookQueries } from '../edu-content-book';
import { MethodQueries } from '../method';

export const getIdByBookId = (bookId: number) =>
  createSelector(
    EduContentBookQueries.getAllEntities,
    MethodQueries.getAllEntities,
    (eduContentBookDict: Dictionary<EduContentBookInterface>, methodDict: Dictionary<MethodInterface>) => {
      const book = eduContentBookDict[bookId];
      const method = methodDict[book?.methodId];

      return method?.learningAreaId;
    }
  );
